import Vue from 'vue';
import VueRouter from 'vue-router';
import goTo from 'vuetify/es5/services/goto';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/auth/login',
    meta: {
      code: '*'
    }
  },
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "group-auth" */ '@/layouts/blank-layout/Blanklayout'),
    meta: {
      code: '*'
    },
    children: [
      {
        name: 'authlogin',
        path: 'login',
        component: () => import(/* webpackChunkName: "group-auth-login" */ '@/gmo_votacion/authentication/views/Login'),
        meta: {
          code: '*'
        }
      }
    ]
  },
  /************************ VOTACIONES ******************************/
  {
    path: '/inicio',
    component: () => import(/* webpackChunkName: "group-inicio" */ '@/layouts/full-layout/Layout'),
    meta: {
      code: '*'
    },
    children: [
      {
        name: 'inicio',
        path: '',
        component: () =>
          import(/* webpackChunkName: "group-inicio-inicio" */ '@/gmo_votacion/inicio/inicio/views/Inicio'),
        meta: {
          code: '*'
        }
      }
    ]
  },
  {
    path: '/votacion',
    component: () => import(/* webpackChunkName: "group-votacion" */ '@/layouts/full-layout/Layout'),
    meta: {
      code: '*'
    },
    children: [
      {
        name: 'votar',
        path: 'votar',
        component: () =>
          import(/* webpackChunkName: "group-votacion-votar" */ '@/gmo_votacion/votar/votar/views/Votar'),
        meta: {
          code: 'votar'
        }
      },
      {
        name: 'analiticas',
        path: 'analiticas',
        component: () =>
          import(/* webpackChunkName: "group-votacion-analiticas" */ '@/gmo_votacion/votar/dashboard/views/Dashboard'),
        meta: {
          code: 'analiticas'
        }
      },
      {
        name: 'reportes',
        path: 'reportes',
        component: () =>
          import(/* webpackChunkName: "group-votacion-reportes" */ '@/gmo_votacion/votar/reporte/views/Reporte'),
        meta: {
          code: 'reportes'
        }
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import(/* webpackChunkName: "unauthorized" */ '@/components4x/authentication/Unauthorized'),
    meta: {
      code: '*'
    }
  },
  {
    path: '*',
    component: () => import('@/views/authentication/Error'),
    meta: {
      code: '*'
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  }
  // This is for the scroll top when click on any router link
});

export default router;
